import { Eyebrow, Reveal } from '@nexa/ui';

interface SampleAgent {
  readonly initials: string;
  readonly name: string;
  readonly body: string;
  readonly chips: readonly string[];
}

export interface SampleAgentCardsProps {
  readonly eyebrow: string;
  readonly samples: readonly SampleAgent[];
}

/**
 * Sáu card agent mẫu + eyebrow của khối — `template.html:930-938`.
 *
 * Ô chữ viết tắt dùng `--text-micro` (11px, :932-937). Đây KHÔNG phải avatar theo nghĩa
 * `reference.md` §3 (30×30, radius-pill, 4 cặp tint): thiết kế vẽ nó 32×32, bo 9px, nền trắng
 * đặc, một tint duy nhất. Nên nó dựng tại chỗ chứ không mượn recipe avatar.
 *
 * Chip cũng dựng tại chỗ: `Badge` có 4 tone và không tone nào là "viền trắng-alpha trên nền tối"
 * (`brand` và `neutral` đều là nền đặc trên nền sáng).
 */
export function SampleAgentCards({ eyebrow, samples }: SampleAgentCardsProps) {
  return (
    <>
      <Reveal className="mt-[34px]">
        <Eyebrow tone="on-dark">{eyebrow}</Eyebrow>
      </Reveal>

      <div className="mt-4 grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {samples.map((agent) => (
          <Reveal key={agent.name} className="h-full">
            <div className="h-full rounded-card border border-[var(--on-dark-line-16)] bg-[var(--on-dark-fill-07)] p-[22px] transition [transition-duration:var(--duration-hover)] hover:bg-[var(--on-dark-fill-12)]">
              <div className="flex items-center gap-2.5">
                <span className="grid size-8 place-items-center rounded-chip bg-surface text-micro font-bold text-brand-600">
                  {agent.initials}
                </span>
                <span className="text-title font-bold text-white">{agent.name}</span>
              </div>
              <p className="mt-3 text-body-sm text-[var(--on-dark-text-70)]">{agent.body}</p>
              <div className="mt-3.5 flex flex-wrap gap-1.5">
                {agent.chips.map((chip) => (
                  <span
                    key={chip}
                    className="rounded-pill border border-[var(--on-dark-line-22)] px-[9px] py-[3px] text-micro text-brand-300"
                  >
                    {chip}
                  </span>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </>
  );
}
